import { createApp, useTemplateRef } from './vue.esm-browser.js';
import './dayjs.min.js';
import { useWindowSize } from './vueuse.core.mjs';
import { useMemo } from './doyo.useReactHooks.js';
import { useShipDate } from './doyo.useShipDate.js';
import { isMobile } from './doyo.utils.js';
import ShipTipDialog from './doyo.ship.dialog.comp.js';

(() => {
  const { Log } = useColorLogger('Order-TIMELINE', { color: '#3fc' });
  if (dayjs) {
    // do nth
    Log('has dayjs');
  } else {
    Log('no dayjs');
  }

  const app = createApp({
    name: 'OrderTimelineApp',
    template: '#tpl-order-timeline-app',
    components: {
      ShipTipDialog,
    },
    setup() {
      const dialogRef = useTemplateRef('tipDialogRef');

      const openDialog = evt => {
        Log('open btn clicked', evt);
        evt.preventDefault();

        if (dialogRef.value) {
          dialogRef.value?.open();
        }
      };

      const { placedDate, shipTime, deliveredTime } = useShipDate();

      const { width } = useWindowSize();
      const isPlatformMobile = useMemo(() => isMobile());
      const smallScreen = useMemo(() => width.value <= 1024);
      const normalPCScreen = useMemo(() => !smallScreen.value && !isPlatformMobile.value);

      return {
        placedDate,
        shipTime,
        deliveredTime,
        openDialog,
        normalPCScreen,
      };
    },
  });

  app.config.compilerOptions.delimiters = ['${', '}$'];

  app.mount('#order-time-app');
})();
